import React from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

const BubbleClose = (props: any) => {
  const { onClose, content, children, ...rest } = props;

  return (
    <Bubble
      dark
      placement="bottom-end"
      escapeWithReference={true}
      overlayClassName="db-bubble-close-overlay"
      content={
        <div className="db-bubble-close-wrap">
          {content}
          <i className="db-bubble-close-icon">
            <SvgIcon type="clonse" />
          </i>
        </div>
      }
      onClick={() => {
        onClose?.();
      }}
      {...rest}
    >
      {children}
    </Bubble>
  );
};

export default BubbleClose;
